import React, { Component } from 'react'
import TimeUnit from './TimeUnit'

class Day extends Component {
  lastUpdate = new Date().getTime()

  state = {
    interacting: false,
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      (this.state.interacting &&
        new Date().getTime() - this.lastUpdate > 16 &&
        (this.lastUpdate = new Date().getTime())) ||
      JSON.stringify(nextProps.slots) !== JSON.stringify(this.props.slots) ||
      this.props.isToday !== nextProps.isToday
    )
  }

  render() {
    const {
      day,
      slots,
      tag,
      action,
      label,
      courseInfo,
      isToday,
      isSlotAvailable,
      isHalf,
    } = this.props

    return (
      <div
        className={'day' + (isToday ? ' today' : '')}
        onMouseEnter={() => this.setState({ interacting: true })}
        onMouseLeave={() => this.setState({ interacting: false })}
      >
        <div className='slotsContainer'>
          {Array.from({ length: 48 }).map((time, i) => {
            const slot = slots.find((slot) => slot.start <= i && slot.end > i)
            return (
              <TimeUnit
                key={`timeUnit-day-${day}-time-${i}`}
                tag={slot ? tag.marked : tag.unmarked}
                label={
                  slot && slot.start === i
                    ? label instanceof Function
                      ? label(day, i, null, courseInfo, slot.hoverInfo)
                      : label
                    : ''
                }
                isHalf={isHalf}
                onClick={() => {
                  typeof action === 'function' && action(day, i, !!slot, slot)
                }}
                onMouseDown={() => {
                  action.pressed && action.pressed(day, i, !!slot, slot)
                }}
                onMouseMove={() => {
                  action.move && action.move(day, i, !!slot, slot)
                }}
                onMouseUp={() => {
                  action.released && action.released(day, i, !!slot, slot)
                }}
                available={isSlotAvailable(day, i, !!slot)}
                childStyle={{
                  transform: slot
                    ? `translate( 0, ${(slot.end - slot.start - 1) * 50}% )`
                    : ``,
                }}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default Day
